import { readBoardColumns } from './read'
import { updateBoardColumn } from './update'

export const boardColumns = {
  readCollection: readBoardColumns,
  update: updateBoardColumn,
}
